<template>
  <section id="section1">
    <!-- <img class="topbar" src="media/global/topbar.png"/>
    <img class="main-logo" src="media/global/logo.png"/> -->
    <!-- Portrait Modal -->
    <transition
      name="modal"
      enter-active-class="animated fadeIn"
      leave-active-class="animated fadeOut">
        <div class="mobile-modal" v-show="$mq === 'mobilep' || $mq === 'tabletp'">
          <div class="mainbox">
            <p v-html="this.$store.state.items.portraitAlert"></p>
            <p><i class="fas fa-2x fa-redo"></i></p>
          </div>
        </div>
    </transition>

    <page1 v-if="location === 1"></page1>
    <page2 v-if="location === 2"></page2>
    <page3 v-if="location === 3"></page3>
    <page4 v-if="location === 4"></page4>
    <!-- <page5 v-if="location === 5"></page5> -->
    <page6 v-if="location === 5"></page6>
    <page7 v-if="location === 6"></page7>

    <button-back></button-back>
    <button-next></button-next>

  </section>
</template>

<script>
import page1 from './pages/Page1.vue'
import page2 from './pages/Page2.vue'
import page3 from './pages/Page3.vue'
import page4 from './pages/Page4.vue'
import page5 from './pages/Page5.vue'
import page6 from './pages/Page6.vue'
import page7 from './pages/Page7.vue'

import buttonNext from '../../components/ButtonNext.vue'
import buttonBack from '../../components/ButtonBack.vue'

  export default {
    data: function () {
      return {

      }
    },
    computed: {
      location () {
        return this.$store.state.scormLMS.location
      }
    },
    methods: {

    },
    mounted() {

    },
    components: {
      page1, page2, page3, page4, page5, page6, page7, buttonNext, buttonBack
    },
    props: []
  }
</script>

<style scoped>
  .mobile-modal {
    display: flex;
    position: absolute;
    z-index: 1500;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    margin: 0;
    background-color: rgba(50, 50, 50, .99);
  }
  .mainbox {
    background-color: #eee;
    width: 20em;
    height: 250px;
    text-align: center;
    width: 90vw;
    margin: 5vw;
    border-radius: 4px;
    filter: drop-shadow(3px 3px 3px #000000);
    -webkit-filter: drop-shadow(3px 3px 3px #000000);
  }
  .mainbox > p {
    width: 90%;
    margin: auto;
    margin-top: 20px;
    font-family: 'Nunito', sans-serif;
    font-size: 1.25em;
  }
  .mainbox > p:nth-of-type(2) {
    margin-top: 20px;
  }

</style>



// WEBPACK FOOTER //
// Section1.vue?6d39bf60